/* Ombre Bliss — gift-set product page. Reuses the v12 look. Gallery + quantity tiers + AJAX cart. */
(function(){
  var OB = window.OB_GS || {};
  var $ = function(i){ return document.getElementById(i); };
  var inr = function(n){ return '₹' + Math.round(n).toLocaleString('en-IN'); };
  var busy = false;

  var QS = (OB.quick && OB.quick.length) ? OB.quick : [1,2,3];
  var LABELS = (OB.labels || '').split('|');
  var BADGES = (OB.badges || '').split('|');
  var unit = OB.unit || 0, mrp = OB.mrp || unit;
  var qty = QS[0] || 1;

  /* gallery */
  var main = $('gsMain');
  Array.prototype.forEach.call(document.querySelectorAll('#gsThumbs .th'), function(t){
    t.addEventListener('click', function(){
      if(main && t.dataset.src) main.src = t.dataset.src;
      document.querySelectorAll('#gsThumbs .th').forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  /* quantity tiers — same markup/classes as the Classic page */
  function renderTiers(){
    $('gsTiers').innerHTML = QS.map(function(q, i){
      var lab = (LABELS[i] || (q + ' set' + (q>1?'s':''))).split(' · ');
      var name = lab[0], sub = lab.slice(1).join(' · ');
      var badge = (BADGES[i] || '').trim();
      var pr = unit * q, was = mrp * q;
      return '<button class="tier ' + (q===qty?'on':'') + '" data-q="' + q + '">'
        + (badge ? '<span class="bdg2 ' + (i===QS.length-1?'o':'') + '">' + badge + '</span>' : '')
        + '<span class="rad"></span>'
        + '<span><span class="n">' + name + '</span>' + (sub ? '<span class="s">' + sub + '</span>' : '') + '</span>'
        + '<span class="pr">' + (was>pr ? '<span class="b">' + inr(was) + '</span>' : '') + '<span class="a">' + inr(pr) + '</span></span>'
        + '</button>';
    }).join('');
    Array.prototype.forEach.call($('gsTiers').querySelectorAll('.tier'), function(b){
      b.onclick = function(){ setQty(+b.dataset.q); };
    });
  }

  function setQty(q){ qty = q; renderTiers(); paint(); }

  function paint(){
    var pr = unit * qty, was = mrp * qty;
    if($('gsTot')) $('gsTot').textContent = inr(pr);
    if($('gsWas')) $('gsWas').textContent = was>pr ? inr(was) : '';
    if($('gsNote')) $('gsNote').textContent = was>pr ? ('You save ' + inr(was - pr)) : '';
    if($('gsBarP')) $('gsBarP').textContent = inr(pr);
    if($('gsBarM')) $('gsBarM').textContent = qty + ' set' + (qty>1?'s':'');
  }

  var tt;
  function toast(m){ var t = $('gsToast'); if(!t) return; t.textContent = m; t.classList.add('up'); clearTimeout(tt); tt = setTimeout(function(){ t.classList.remove('up'); }, 2200); }

  function add(then){
    if(busy || !OB.vid || !OB.available) return;
    busy = true;
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id: OB.vid, quantity: qty }] }) })
      .then(function(r){ return r.json(); })
      .then(function(){ 
        busy = false; 
        if(then==='checkout'){ /* Buy now → GoKwik checkout */
          var varInput = document.getElementById('gkHiddenVariant');
          var qtyInput = document.getElementById('gkHiddenQty');
          if (varInput) varInput.value = OB.vid;
          if (qtyInput) qtyInput.value = qty;
          
          var gkBuyNowBtn = document.getElementById('gokwik-buy-now');
          if (gkBuyNowBtn && typeof window.onBuyNowClick === 'function') {
            gkBuyNowBtn.click();
            return;
          }
          if (typeof window.onBuyNowClick === 'function') {
            window.onBuyNowClick(null, '#gkBuyNowForm');
            return;
          }
          var gkBtn = document.getElementById('gk-hidden-checkout') || document.querySelector('.gokwik-checkout button');
          if (gkBtn) { gkBtn.click(); } else { window.location.href='/checkout'; }
          return;
        } else { 
          toast('Added — opening your cart');
          var bubble = document.querySelector('#cart-icon-bubble');
          if(bubble) bubble.click();
          else window.location.href = '/cart';
        } 
      })
      .catch(function(){ busy = false; toast('Something went wrong — try again'); });
  }
  if($('gsAdd'))    $('gsAdd').onclick    = function(){ add('cart'); };
  if($('gsBarAdd')) $('gsBarAdd').onclick = function(){ add('cart'); };

  ['gsBuy','gsBarBuy'].forEach(function(i){
    var b=$(i);
    if(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        add('checkout');
      }, true);
    }
  });

  /* sticky bar once the main CTA scrolls off */
  var cta = $('gsAdd'), bar = $('gsBar');
  if(cta && bar && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ bar.classList.toggle('up', !e.isIntersecting); }); }).observe(cta);
  }

  window.addEventListener('pageshow', function(){ busy = false; });

  renderTiers();
  paint();
})();
